import { Network } from "@converge-collective/common/models/Network";
import { SvgIconProps } from "@mui/material";
import dynamic from "next/dynamic";

export type NavItem = {
  label: string;
  icon?: React.ComponentType<SvgIconProps>;
  target?: string;
} & (
  | {
      onClick: () => void;
      url?: never;
    }
  | {
      url: string;
      onClick?: never;
    }
);

export const mainNav = (network: Network): NavItem[] => [
  {
    url: newsFeedRoute(network.slug),
    label: "Feed",
    icon: dynamic(() => import("@mui/icons-material/Home")),
  },
  {
    url: eventsRoute(network.slug),
    label: "Events",
    icon: dynamic(() => import("@mui/icons-material/Event")),
  },
  {
    url: marketplacesRoute(network.slug),
    label: "Marketplace",
    icon: dynamic(() => import("@mui/icons-material/EmojiPeople")),
  },
  {
    url: challengesRoute(network.slug),
    label: "Challenges",
    icon: dynamic(() => import("@mui/icons-material/EmojiEvents")),
  },
  {
    url: myTeamRoute(network.slug),
    label: "My Team",
    icon: dynamic(() => import("@mui/icons-material/Diversity3")),
  },
  {
    url: leaderboardsRoute(network.slug),
    label: "Leaderboards",
    icon: dynamic(() => import("@mui/icons-material/Bookmark")),
  },

  ...(network.settings?.isDirectoryDisabled === true
    ? []
    : [
        {
          url: directoryRoute(network.slug),
          label: "Directory",
          icon: dynamic(() => import("@mui/icons-material/ImportContacts")),
        },
      ]),

  // { url: ulyssesPactRoute(network.slug), label: "Ulysses Pact" },

  {
    url: groupsRoute(network.slug),
    label: "Groups",
    icon: dynamic(() => import("@mui/icons-material/Groups")),
  },
];

export const marketingNavItemsLeft = (slug: string): NavItem[] => [
  {
    url: eventsRoute(slug),
    label: "Events",
    icon: dynamic(() => import("@mui/icons-material/Event")),
  },
  {
    url: marketplacesRoute(slug),
    label: "Marketplace",
    icon: dynamic(() => import("@mui/icons-material/EmojiPeople")),
  },
  {
    url: groupsRoute(slug),
    label: "Groups",
    icon: dynamic(() => import("@mui/icons-material/Groups")),
  },
];

export const marketingNavItemsRight = (
  slug: string,
  homeUrl?: string
): NavItem[] => [
  {
    url: homeUrl || newsFeedRoute(slug),
    label: "Home",
    icon: dynamic(() => import("@mui/icons-material/Home")),
  },
  // { url: `${newsFeedRoute(slug)}/sponsorship`, label: "Sponsorships" },
  {
    url: "/contact",
    label: "Contact",

    icon: dynamic(() => import("@mui/icons-material/AlternateEmail")),
  },
  {
    url: "/about",
    label: "About",

    icon: dynamic(() => import("@mui/icons-material/Info")),
  },
];

// export const leftMarketingNavItems

export const newsFeedRoute = (networkSlug: string): string => `/${networkSlug}`;

export const eventsRoute = (networkSlug: string): string =>
  `/${networkSlug}/events`;

export const marketplacesRoute = (networkSlug: string): string =>
  `/${networkSlug}/marketplace`;

export const eventDetailRoute = (
  networkSlug: string,
  eventSlug: string
): string => `/${networkSlug}/events/${eventSlug}`;

export const postDetailRoute = (networkSlug: string, postId: string): string =>
  `/${networkSlug}/posts/${postId}`;

export const challengesRoute = (networkSlug: string): string =>
  `/${networkSlug}/challenges`;

export const networkAdminRoute = (networkSlug: string): string =>
  `/${networkSlug}/admin`;

export const networkAdminChallengesRoute = (networkSlug: string): string =>
  `/${networkSlug}/admin/challenges`;

export const teamsRoute = (networkSlug: string): string =>
  `/${networkSlug}/teams`;

export const myTeamRoute = (networkSlug: string): string =>
  `/${networkSlug}/my-team`;

export const myTeamPostDetailRoute = (networkSlug: string, postId: string) =>
  `/${networkSlug}/my-team/posts/${postId}`;

export const leaderboardsRoute = (networkSlug: string): string =>
  `/${networkSlug}/leaderboards`;

export const directoryRoute = (networkSlug: string): string =>
  `/${networkSlug}/directory`;

export const ulyssesPactRoute = (networkSlug: string): string =>
  `/${networkSlug}/ulysses-pact`;

export const groupsRoute = (networkSlug: string): string =>
  `/${networkSlug}/groups`;

export const groupDetailRoute = (
  networkSlug: string,
  groupSlug: string
): string => `/${networkSlug}/groups/${groupSlug}`;

export const groupPostDetailRoute = (
  networkSlug: string,
  groupSlug: string,
  postId: string
): string => `/${networkSlug}/groups/${groupSlug}/posts/${postId}`;

export const onboardingRoutes = {
  account: "/onboarding/account",
};
